import { render } from "./AdminCreation.vue?vue&type=template&id=740f7be0&scoped=true"
import script from "./AdminCreation.vue?vue&type=script&lang=js"
export * from "./AdminCreation.vue?vue&type=script&lang=js"

import "./AdminCreation.vue?vue&type=style&index=0&id=740f7be0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740f7be0"]])

export default __exports__